import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { UserType } from "@/root/types";

export interface UserState {
  userType: UserType | null;
  areUsers: boolean;
}

const initialState: UserState = {
  userType: null,
  areUsers: true,
};

export const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setUserType: (state, action: PayloadAction<UserType | null>) => {
      state.userType = action.payload;
    },
    setAreUsers: (state, action: PayloadAction<boolean>) => {
      state.areUsers = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setUserType,
  setAreUsers,
  reset: resetUserState,
} = userSlice.actions;

export default userSlice.reducer;
